import type { CreateLoanInput } from '../types'

export const createLoanInputs: CreateLoanInput[] = [
	{
		title: (intl) =>
			intl.formatMessage({
				defaultMessage: 'Lainan numero',
				description: 'Loan reference number',
			}),
		key: 'referenceNumber',
		show: true,
		type: 'text',
	},
	{
		title: (intl) =>
			intl.formatMessage({
				defaultMessage: 'Lainatyyppi',
				description: 'Loan type',
			}),
		key: 'type',
		show: true,
		type: 'text',
	},
	{
		title: (intl) =>
			intl.formatMessage({
				defaultMessage: 'Lainanantaja',
				description: 'Loan granted by',
			}),
		key: 'grantedBy',
		show: true,
		type: 'text',
	},
	{
		title: (intl) =>
			intl.formatMessage({
				defaultMessage: 'Nostettu lainasumma',
				description: 'Amount drawn',
			}),
		key: 'amountDrawn',
		show: true,
		type: 'number',
		fullWidth: true,
		min: 100,
	},
	{
		title: (intl) =>
			intl.formatMessage({
				defaultMessage: 'Lainan alkupäivä',
				description: 'Loan start date',
			}),
		key: 'startDate',
		show: true,
		type: 'date',
	},
	{
		title: (intl) =>
			intl.formatMessage({
				defaultMessage: 'Lainan loppupäivä',
				description: 'Loan end date',
			}),
		key: 'endDate',
		show: true,
		type: 'date',
	},
	{
		title: (intl) =>
			intl.formatMessage({
				defaultMessage: 'Laina-aika',
				description: 'Loan duration',
			}),
		key: 'duration',
		show: true,
		type: 'text',
	},
	{
		title: (intl) =>
			intl.formatMessage({
				defaultMessage: '1. nostopäivämäärä',
				description: 'First loan draw date',
			}),
		key: 'dateDrawn',
		show: true,
		type: 'date',
	},
	{
		title: (intl) =>
			intl.formatMessage({
				defaultMessage: 'Lyhennystiedot',
				description: 'Amortization sub-heading',
			}),
		key: 'sub-heading',
		show: true,
		type: 'text',
	},
	{
		title: (intl) =>
			intl.formatMessage({
				defaultMessage: '1. lyhennyspäivä',
				description: 'First loan amortization date',
			}),
		key: 'amortizationFirstDueDate',
		show: true,
		type: 'date',
	},
	{
		title: (intl) =>
			intl.formatMessage({
				defaultMessage: 'Lyhennyserä',
				description: 'Loan amortization amount',
			}),
		key: 'amortizationAmount',
		show: true,
		type: 'number',
		min: 0,
	},
	{
		title: (intl) =>
			intl.formatMessage({
				defaultMessage: 'Lyhennyspäivät',
				description: 'Amortization dates',
			}),
		key: 'amortizationDates',
		show: true,
		type: 'day-month',
	},
	{
		title: (intl) =>
			intl.formatMessage({
				defaultMessage: 'Korko',
				description: 'Interest sub-heading',
			}),
		key: 'sub-heading',
		show: true,
		type: 'text',
	},
	{
		title: (intl) =>
			intl.formatMessage({
				defaultMessage: 'Korkosidos',
				description: 'Interest type',
			}),
		key: 'interestType',
		show: true,
		type: 'text',
	},
	{
		title: (intl) =>
			intl.formatMessage({
				defaultMessage: '1. koronmaksupäivä',
				description: 'Interest last changed',
			}),
		key: 'interestFirstDueDate',
		show: true,
		type: 'date',
	},
	{
		title: (intl) =>
			intl.formatMessage({
				defaultMessage: 'Korko (%)',
				description: 'Interest percentage',
			}),
		key: 'startingInterestPercentage',
		show: true,
		type: 'number',
	},
	{
		title: (intl) =>
			intl.formatMessage({
				defaultMessage: 'Marginaali (%)',
				description: 'Marginal percentage',
			}),
		key: 'marginalPercentage',
		show: true,
		type: 'number',
	},
	{
		title: (intl) =>
			intl.formatMessage({
				defaultMessage: 'Koron tarkastus päivämäärät',
				description: 'Interest inspection dates',
			}),
		key: 'interestInspectionDates',
		show: true,
		type: 'day-month',
	},
]
